<template>
  <div id="app">
    <div
      v-if="
        !hideHeader &&
        $route.name !== 'showroom' &&
        $route.name !== 'candidate-closeup-online' &&
        $route.name !== 'candidate-dossier' &&
        $route.name !== 'mobile-privacy-policy' &&
        $route.name !== 'mobile-terms-and-conditions' &&
        $route.name !== 'mobile-imprint'
      "
    >
      <div v-if="isBrandedHeader">
        <header-branded></header-branded>
      </div>

      <div v-else>
        <div v-if="isJobsPage && !isAuthenticated">
          <header-green-jobs></header-green-jobs>
        </div>
        <div v-else>
          <header-green v-if="isAuthenticated"></header-green>
          <header-white v-else></header-white>
        </div>
      </div>
    </div>

    <div
      :class="`app-container ${
        isAuthenticated && $route.name !== 'candidate-closeup-online'
          ? 'has-menu'
          : 'justify-content-center'
      } ${hideFooter ? 'no-max-width' : 'has-padding'} ${hideSideMenuGlobal ? 'px-0' : ''}`"
    >
      <transition name="fade">
        <side-menu
          v-if="
            isAuthenticated &&
            !$isAdmin &&
            !hideFooter &&
            !hideSideMenuGlobal &&
            !isBrandedHeader &&
            $route.name !== 'showroom' &&
            $route.name !== 'candidate-closeup-online' &&
            $route.name !== 'mobile-privacy-policy' &&
            $route.name !== 'mobile-terms-and-conditions' &&
            $route.name !== 'mobile-imprint' &&
            !isBusinessProfile
          "
        />
      </transition>
      <div
        :class="`router-view ${isAuthenticated ? 'has-menu' : ''} ${
          $route.name === 'candidate-dossier' ? 'overflow-scroll' : ''
        }`"
      >
        <skeleton-loader v-if="$root.routerLoading && !hideSkeletonLoader" />
        <transition name="fade">
          <router-view v-if="!$root.routerLoading" />
        </transition>
      </div>
    </div>
    <screen-orientation />
    <div :class="`modal-overlay ${showMenu ? 'show' : ''}`"></div>
    <footer-white
      v-if="
        !hideFooter &&
        $route.name !== 'candidate-closeup-online' &&
        $route.name !== 'mobile-privacy-policy' &&
        $route.name !== 'mobile-terms-and-conditions' &&
        $route.name !== 'mobile-imprint'
      "
    />
  </div>
</template>

<script>
import { openWebSocket } from '@/plugins/websocket'
import { isMobileDevice } from '../utils/device'

export default {
  name: 'app',
  components: {
    'footer-white': () => import('./shared/footer-white/footer-white.component.vue'),
    'header-white': () => import('./shared/header-white/header-white.component.vue'),
    'header-green': () => import('./shared/header-green/header-green.component.vue'),
    'header-branded': () => import('./shared/header-branded/header-branded.component.vue'),
    'header-green-jobs': () => import('./shared/header-green-jobs/header-green-jobs.component.vue'),
    'side-menu': () => import('@/components/shared/side-menu'),
    'skeleton-loader': () => import('@/components/shared/skeleton'),
    'screen-orientation': () => import('@/components/shared/screen-orientation'),
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['authModule/isAuthenticated']
    },
    isBusinessProfile() {
      if (this.$isCandidate) {
        return this.$route.name === 'business-profile-public' && this.windowWidth > 992
      } else {
        return this.$route.name === 'business-profile-public'
      }
    },
  },
  data() {
    return {
      showMenu: false,
      isJobsPage: this.$route.name === 'jobs',
      isFacebookPixelLoaded: false,
      hideHeader: false,
      windowWidth: window.screen.width,
      hideFooter: false,
      isCandidateBPView:
        this.$route.name === 'business-profile-public' &&
        localStorage.getItem('userType') === 'Candidate',
      hideSideMenuGlobal: false,
      hideSkeletonLoader: false,
      skeletonLoaderFilter: ['logout'],
      isBrandedHeader:
        this.$route.name === 'candidate-profile' || this.$route.name === 'candidate-profiles',
    }
  },
  watch: {
    $route() {
      this.routeChanged()
    },
  },
  beforeMount() {
    this.hideMenuGlobalEvent()
    this.changeAppLanguage()
    this.checkUserAuth()
    // this.loadHubspotScript()
    window.$store = this.$store
  },
  mounted() {
    this.loadFacebookPixel()
    document.body.className = 'not-logged-in'
  },
  methods: {
    hideMenuGlobalEvent() {
      this.$eventHub.$on('hideMenu', e => {
        this.hideSideMenuGlobal = e
      })
    },
    checkWindowSize() {
      this.windowWidth = window.screen.width
    },
    checkUserAuth() {
      let token = localStorage.getItem('_verificationToken')
      if (token) {
        openWebSocket()

        this.$store.dispatch('authModule/authenticateFromToken', token)

        this.setUserProps({
          userType: localStorage.getItem('userType'),
          email: localStorage.getItem('userEmail'),
        })

        if (this.$isRecruiter) {
          this.fetchRecruiterInfo()
        } else if (this.$isCandidate) {
          this.fetchCandidateInfo()
        }
      }
    },
    routeChanged() {
      // TODO: Change this retarded code.
      const routeName = this.$route.name
      this.hideSkeletonLoader = this.skeletonLoaderFilter.includes(routeName)
      this.$isAdmin = routeName.includes('admin-panel')
      this.isBrandedHeader = routeName === 'candidate-profile' || routeName === 'candidate-profiles'

      document.body.className = 'not-logged-in'
      document.body.classList.add(routeName)

      if (
        routeName === 'business-profile-public' &&
        localStorage.getItem('userType') === 'Candidate'
      ) {
        window.addEventListener('resize', this.checkWindowSize)
      } else {
        window.removeEventListener('resize', this.checkWindowSize)
      }

      if (this.isAuthenticated) {
        document.body.classList.remove('not-logged-in')
      }

      this.hideFooter =
        routeName.indexOf('video-interview') > -1 ||
        routeName.indexOf('job-interview') > -1 ||
        routeName.indexOf('profile-video-upload') > -1
      //|| routeName.indexOf('ci-signup') > -1

      this.hideHeader =
        routeName.indexOf('video-interview') > -1 ||
        routeName.indexOf('profile-video-upload') > -1 ||
        routeName.indexOf('job-interview') > -1 ||
        routeName.indexOf('candidate-closeup-online') > -1 ||
        routeName.indexOf('ci-signup') > -1

      this.loadFacebookPixel()
    },
    loadHubspotScript() {
      if (isMobileDevice()) return
      window.setTimeout(() => {
        var hobspotScript = document.createElement('script')
        hobspotScript.type = 'text/javascript'
        hobspotScript.id = 'hs-script-loader'
        hobspotScript.src = '//js.hs-scripts.com/4837770.js'
        document.getElementsByTagName('head')[0].appendChild(hobspotScript)
      }, 5000)
    },
    loadFacebookPixel() {
      if (!this.isFacebookPixelLoaded && this.$route.name === 'closeup-landing') {
        ;(function (f, b, e, v, n, t, s) {
          if (f.fbq) return
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          }
          if (!f._fbq) f._fbq = n
          n.push = n
          n.loaded = !0
          n.version = '2.0'
          n.queue = []
          t = b.createElement(e)
          t.async = !0
          t.src = v
          s = b.getElementsByTagName(e)[0]
          s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
        window.fbq('init', '165687013986450')
        window.fbq('track', 'PageView')
        this.isFacebookPixelLoaded = true
      }
    },
    fetchRecruiterInfo() {
      this.$store
        .dispatch('recruiterSettingsModule/recruiterInfo')
        .then(response => {})
        .catch(e => {
          console.error(e)
        })
    },
    fetchCandidateInfo() {
      this.$store
        .dispatch('candidateSettingsModule/getCandidateInfo')
        .then(response => {})
        .catch(e => {
          console.error(e)
        })
    },
  },
}
</script>
<style lang="scss">
@mixin lineTruncate($font-size, $line-height, $lines-to-show) {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  max-height: $line-height * $lines-to-show;
  font-size: $font-size;
  line-height: $line-height;
  -webkit-line-clamp: $lines-to-show;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
#app {
  font-family: var(--font-style) !important;
  .app-container {
    width: 100%;
    &.no-max-width {
      max-width: unset;
    }
    // &.has-padding {
    // padding: 0 12px; // unnecessary padding
    // }
    &.has-menu {
      max-width: 1390px;
      margin: 0 auto;
      display: flex;
      padding: 0;
    }
    .router-view {
      width: 100%;
    }
    .overflow-scroll {
      overflow: scroll;
    }
  }
}

// Hide candidate-details page on print for candidate dossier feature

@page {
  size: A4;
  margin: 0;
  // margin-top: 20px;
}

@media print {
  .candidate-details {
    #app {
      display: none;
    }
    &:before {
      content: 'Please use candidate dossier feature';
      background-color: white;
      font-size: 3rem;
      text-align: center;
      padding-top: 600px;
      display: block;
      height: 1400px;
    }
  }
}
</style>
